import { ReactNode, useEffect } from 'react';
import { DataGridHandler, DataGridFilters } from './DataGridHandler';

export interface DataGridSyncParams<TData, TContext> {
  handler: DataGridHandler<TData, TContext>;
  data?: TData[];
  context?: TContext;
  title?: string | { title: string; tableTitle: ReactNode };
  loading?: boolean;
  filters?: DataGridFilters;
}

const useDataGridSync = <TData, TContext>({
  handler,
  data,
  context,
  title,
  loading,
  filters,
}: DataGridSyncParams<TData, TContext>) => {
  useEffect(() => {
    if (data !== undefined) {
      handler.setData(data);
    }
  }, [handler, data]);

  useEffect(() => {
    if (context !== undefined) {
      handler.setContext(context);
    }
  }, [handler, context]);

  useEffect(() => {
    if (title !== undefined) {
      handler.setTitle(title);
    }
  }, [handler, title]);

  useEffect(() => {
    if (loading !== undefined) {
      handler.setLoading(loading);
    }
  }, [handler, loading]);

  useEffect(() => {
    if (filters !== undefined) {
      handler.setFilters(filters);
    }
  }, [handler, filters]);
};

export default useDataGridSync;
